"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startGame = void 0;
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var startGame = function () { return core_1.di.get(interfaces_1.TypesFlow.boot).run(); };
exports.startGame = startGame;
//# sourceMappingURL=gameLauncher.js.map